<template>
  <svg class="bandeira" viewBox="0 0 30 20" aria-hidden="true">
    <template v-if="codigo === 'pt'">
      <rect width="30" height="20" fill="#009c3b" />
      <polygon points="15,2.5 27.5,10 15,17.5 2.5,10" fill="#ffdf00" />
      <circle cx="15" cy="10" r="4.4" fill="#002776" />
    </template>
    <template v-else-if="codigo === 'en'">
      <rect width="30" height="20" fill="#fff" />
      <rect v-for="i in 7" :key="i" y="0" :transform="`translate(0 ${(i - 1) * 3.08})`" width="30" height="1.54" fill="#b22234" />
      <rect width="13" height="10.8" fill="#3c3b6e" />
    </template>
    <template v-else>
      <rect width="30" height="20" fill="#aa151b" />
      <rect y="5" width="30" height="10" fill="#f1bf00" />
    </template>
  </svg>
</template>

<script setup lang="ts">
import type { Idioma } from '../../i18n/idioma'

defineProps<{ codigo: Idioma }>()
</script>

<style scoped>
.bandeira {
  width: 20px;
  height: 14px;
  border-radius: 2px;
  flex-shrink: 0;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.12);
}
</style>
